import { inject } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { HttpInterceptorFn } from '@angular/common/http';
import { finalize } from 'rxjs/operators';

// Counter to track active requests
let activeRequests = 0;

export const SpinnerInterceptorFn: HttpInterceptorFn = (req, next) => {
  const ngxSpinnerService: NgxSpinnerService = inject(NgxSpinnerService);
  const skipSpinner = req.headers.get('X-Skip-Spinner') === 'true';

  const modifiedRequest = req.clone({ headers: req.headers.delete('X-Skip-Spinner') });

  if (!skipSpinner) {
    // Show the spinner if this is the first active request
    if (activeRequests === 0) {
      ngxSpinnerService.show();
    }
    activeRequests++;
  }

  return next(modifiedRequest).pipe(
    finalize(() => {
      if (!skipSpinner) {
        activeRequests--;
        // Only hide the spinner if all requests are completed
        if (activeRequests === 0) {
          setTimeout(() => {
            ngxSpinnerService.hide();
          }, 100); // Optional delay for smoother transition
        }
      }
    }),
  );
};
